import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {
    BrowserRouter
} from "react-router-dom";
import App from './App';
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import 'font-awesome/css/font-awesome.min.css';
import reportWebVitals from './reportWebVitals';
import "./assets/css/App.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>
);
